<template>
    <div v-if="gifts.length && giftTreshold <= cartTotal">
        <div  class="col-12 mt20 mb10 present">
            <div class="presentInner active">
                <span class="col-12 title-8 regularFont fontColor">
                    <i class="fa fa-check greenLightColor mr5"></i> <span v-html="label('shop.cart.gift.title')"></span>
                </span>
            </div>
            <div class="presentsCol active">
                <div class="col-12 grid-2">
                    <div v-for="(gift, index) in gifts" v-if="showMore || index < 2" class="col-12 p10 whiteBack presents" :class="(selected == gift.id ? 'selected' : '')" @click="selectGift(gift)">
                        <div class="bookImage small">
                            <div class="centerDiv">
                                <div class="bookInner">
                                    <img :src="gift.thumbnail_src"
                                         :data-src="gift.thumbnail_src"
                                         :alt="gift.title">
                                </div>
                            </div>
                        </div>
                        <div class="bookSmallRight">
                            <span class="col-12 title-8 blueDarkColor boldFont fontSmooth noDecorationTitle">{{ gift.title }} <a href="#" @click="openModal(gift.id+'-modal')" class="fancybox"><i class="ml5 fa fa-info-circle titleColor fs16"></i></a></span>
                            <div class="paragraph col-12 small">{{ getAuthorString(gift) }}</div>
                        </div>
                    </div>
                </div>
                <span class="title-8 mt20 centerText col-12 pointer showMore fontColor" @click="toggleShowMore()"> {{ showMoreButton }} <i class="ml10 fa" :class="(!showMore ? 'fa-caret-down' : 'fa-caret-up')"></i></span>
            </div>
        </div>

        <div v-for="(gift, index) in gifts" :id="gift.id+'-modal'" style="display: none;">
            <div class="col-4 col-padding-right">
                <div class="book">
                    <div class="book-cover" colorify-main-color>
                        <img :src="gift.thumbnail_src"
                             :data-src="gift.thumbnail_src"
                             :alt="gift.title">
                    </div>
                    <div class="book-spine">
                    </div>
                </div>
            </div>
            <div class="col-8 col-padding-left-big">
                <div class="col-12 m-mt30">
                    <span class="col-12 title-4 mt5 titleColor boldFont fontSmooth">{{ gift.title}}</span>
                    <div class="col-12">
                        <div class="paragraph small blueDarkColor col-12">
                            <span v-for="(author, key) in gift.authors">
                                <a :href="author.fullSlug" target="_blank" >{{ author.name }}</a> {{ (key < author.length ? ',' : '')}}
                            </span>
                        </div>
                        <div class="paragraph small blueDarkColor col-12 mt10">
                            <strong v-if="gift.categoryLabels != ''">{{ label('shop.product.subject') }}: {{ gift.categoryLabels }}</strong>
                            <div class="paragraph small blueDarkColor col-12 mt10" v-html="gift.description_short"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import translations from "../mixins/translations";

export default {
    name: "cart-gift",
    components: {
    },
    mixins: [
        translations
    ],
    props: {
        classes: {
            required: false,
            type: String,
            default: "button green withIcon w100p floatNone"
        }
    },
    data() {
        return {
            currentLang: {},
            showButtons: false,
            showMore: false,
        }
    },
    methods: {
        toggleShowMore() {
            this.showMore = !this.showMore;
        },
        getAuthorString(gift) {
            return gift.authors.map(author => author.name).join(', ');
        },
        giftThumbnail(gift) {
            if (gift.thumbnail) {
                return gift.thumbnail.image_path;
            }
            return '/images/products/no-photo.jpg';
        },
        selectGift(gift) {
            if (this.selected != gift) {
                this.$store.dispatch('cart/updateSelectedGift', gift.id);
            }
        },
        openModal(id) {
            $.fancybox.open({
                src: `#${id}`,
            });
        }
    },
    computed: {
        gifts() {
            return this.$store.state.cart.gifts;
        },
        giftTreshold() {
            return this.$store.state.cart.cart.giftThreshold;
        },
        cartTotal() {
            return this.$store.state.cart.cart.totalPriceExcl;
        },
        selected() {
            return this.$store.state.cart.selectedGift;
        },
        showMoreButton() {
            return !this.showMore ? this.label('shop.cart.gift.show-more') : this.label('shop.cart.gift.show-less');
        }
     },
    watch: {},
    mounted() {

    }
}
</script>
